import angular from 'angular';
import indexMetricHealth from './index-metric-health.component';

export default angular.module('eshq.indexMetricHealth', [])
  .component('eshqIndexMetricHealth', indexMetricHealth)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-health/index-metric-health.js